import { EGameStoreKeys, IGameStoreSchema, TUILayerGameStoreSchema } from './GameStoreSchema';

export const transformUpdateToUILayer = (registryData: IGameStoreSchema): TUILayerGameStoreSchema => {
    const uiLayerDTO = { ...registryData, [EGameStoreKeys.VisibleSymbols]: undefined };
    return uiLayerDTO;
};
